import React, { Component } from 'react';
import * as styled from './logo.styled';

class Logo extends Component {

    constructor() {
        super();
    }

    componentDidCatch(){}

    render() {
        return (
            <styled.LogoContainer style={{height: `${this.props.screenHeight}px`}} className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                <h1>
                    <styled.LogoItalic>Malina</styled.LogoItalic>
                    <styled.LogoNormal>Corpadean</styled.LogoNormal>
                </h1>
            </styled.LogoContainer>
        );
    }
}

export default Logo;